import React, { useState } from 'react';
import {
	InputAdornment,
	makeStyles,
	TextField,
	FormControlLabel,
	useMediaQuery,
	IconButton,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
	container: {
		placeItems: 'normal',
		maxWidth: ({ isMobile }) => isMobile && 200,
		width: ({ isMobile, width }) => (isMobile ? 200 : width),
		margin: 0,
	},
	label: {
		minWidth: 120,
		marginRight: 10,
		color: ({ disabled, touched, hover }) =>
			(touched || hover) && !disabled ? theme.palette.primary.main : 'black',
	},
}));

const SimplePassword = ({
	label,
	labelPos = 'top',
	placeholder,
	name,
	onChange = () => {},
	value,
	disabled = false,
	width = '100%',
	style = {},
	containerClass = '',
}) => {
	const isMobile = useMediaQuery('(max-width: 768px)');
	const [showPassword, setShowPassword] = useState(false);
	const [touched, setTouched] = useState(false);
	const [hover, setHover] = useState(false);
	const classes = useStyles({ isMobile, disabled, width, touched, hover });

	const handleClickShowPassword = () => setShowPassword(!showPassword);

	return (
		<FormControlLabel
			className={classes.container + ` ${containerClass}`}
			label={<p className={classes.label}>{label}</p>}
			labelPlacement={isMobile ? 'top' : labelPos}
			control={
				<TextField
					fullWidth
					style={style}
					size="small"
					variant="outlined"
					type={showPassword ? 'text' : 'password'}
					placeholder={placeholder ? placeholder : label}
					name={name}
					onChange={onChange}
					value={value}
					disabled={disabled}
					onMouseEnter={() => setHover(true)}
					onMouseLeave={() => setHover(false)}
					onBlur={() => setTouched(false)}
					onFocus={(e) => setTouched(true)}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									onClick={handleClickShowPassword}
								>
									{showPassword ? <Visibility /> : <VisibilityOff />}
								</IconButton>
							</InputAdornment>
						),
					}}
				/>
			}
		/>
	);
};

export default SimplePassword;
